/* sts-step-fallback.js (STS.stepFallback): what a routine step shows when its
   own data falls short, on every surface that draws one (home glance, My
   routine widget, Skin Profile, results). Loaded before their scripts; each
   still works without it.

   paint(img, step, width) - Emma, 2026-10-01, empty glance tiles: the step's
   image; with none, a failed one or a spacer, its product's looked up by
   handle (/products/<handle>.js) or, a legacy item having only a variant id,
   via the /variants/<id> redirect, or (both gone) by exact title - the
   variant's picture, else the product's first image or media; else the
   step-category icon (data-sts-ph). Never an empty frame.

   standIn(step) - Luis, 2026-10-01, "show the best in-stock swap": a sold-out
   step shows its first in-stock swapCandidate (backend stock order; approved
   only, #709; best sellers first in the picker A/B "few" arm). Display only
   and made again on every load, so the original returns when restocked; it
   is kept in oosOriginal. keep(step), "Keep waiting for it", puts it back and
   remembers that on this device (sts.oosWait). No alternative: out of stock. */
(function (w, d) {
  'use strict';

  var STS = (w.STS = w.STS || {});
  if (STS.stepFallback) return;

  function str(v) { return v == null || v === '' ? '' : String(v).split('/').pop(); }
  function vidOf(s) { return str(s && (s.dtcVariantId || s.variantId || s.variant_id)); }
  function handleOf(s) { return s && s.handle ? String(s.handle).replace(/^\/+(products\/)?/, '') : ''; }
  function titleOf(s) { return (s && (s.title || s.productTitle || s.name)) || ''; }
  /* A picture URL, or ''. An {src}/{url} object is read through; a data: URI
     is not a product photo - it is a lazy card's spacer, copied before the
     card loaded (sts-add-routine.js card(): img.currentSrc || img.src), and
     drew as a blank tile (STS-HOME-ROUTINE-IMG-1014). */
  function own(s) {
    var u = s && (s.image || s.imageUrl || s.image_url);
    u = u && typeof u === 'object' ? u.src || u.url : u;
    u = u ? String(u) : '';
    return /^(https?:)?\/\/|^\/[^/]/.test(u) ? u : '';
  }
  /* The same file, whatever the protocol or size parameter. */
  function bare(u) { return String(u || '').replace(/^https?:/, '').split('?')[0]; }

  /* Line icons by slot family: pump bottle, dropper (treatment, exfoliant,
     toner), jar, sun, eye, else a bottle. HA01-05: the hypoallergenic
     cleanser, cleanser, moisturizer, sunscreen, eye cream. */
  var P = {
    C: 'M9 9h6l1 3v8.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V12zM11 9V6h2v3M13 6h3',
    T: 'M10 2h4v4h-4zM9 6h6v2l-1 1v9a2 2 0 0 1-4 0V9L9 8z',
    M: 'M5 11h14v8a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zM6 11V7h12v4',
    S: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
    E: 'M2 12s3.6-6 10-6 10 6 10 6-3.6 6-10 6S2 12 2 12zM12 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z',
    X: 'M8 3h8v4H8zM7 7h10v13a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z'
  };
  var FAM = { HA01: 'C', HA02: 'C', HA03: 'M', HA04: 'S', HA05: 'E', SPF: 'S', EX: 'T', TN: 'T' };

  /* Half the box (the viewBox margin), a stroke that does not scale: the same
     in a 34px row and a 175px card. */
  function icon(slot) {
    var s = String(slot || '').trim().toUpperCase();
    var f = FAM[s] || (STS.slotFam ? STS.slotFam(s) : (/^[A-Z]+/.exec(s) || [''])[0]);
    f = FAM[f] || f;
    return 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="-12 -12 48 48" fill="none" stroke="#8A8DA3" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path vector-effect="non-scaling-stroke" d="' + (f.length === 1 && P[f] || P.X) + '"/></svg>');
  }

  function sized(u, width) {
    u = String(u);
    return !width || /[?&]width=/.test(u) || !/cdn\.shopify\.com|\/cdn\/shop\//.test(u) ? u : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  var memo = {};
  /* The product JSON, or null. */
  function byHandle(h) {
    return memo['h' + h] || (memo['h' + h] = w.fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; }));
  }
  /* The step's own variant's picture, else the product's featured image,
     its first image, its first media's preview; '' when it has none. */
  function pic(p, v) {
    var vi = (p.variants || []).filter(function (x) { return str(x.id) === v; })[0], m = (p.media || [])[0];
    return (vi && vi.featured_image && vi.featured_image.src) || p.featured_image || (p.images || [])[0] ||
      (m && m.preview_image && m.preview_image.src) || '';
  }
  function norm(t) { return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  /* Last resort for a step whose handle and variant both 404 - a handle
     renamed or a product retired for a repackaged twin: the published
     product with exactly this title (letters and digits only, so "Plated
     SkinScience" finds "Plated Skin Science"), else nothing. */
  function byTitle(t) {
    var k = norm(t);
    if (k.length < 8) return Promise.resolve(null);
    return memo['t' + k] || (memo['t' + k] = w.fetch('/search/suggest.json?q=' + encodeURIComponent(t) + '&resources[type]=product&resources[limit]=6', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var hit = ((j && j.resources && j.resources.results && j.resources.results.products) || [])
          .filter(function (p) { return norm(p.title) === k; })[0];
        return hit ? byHandle(hit.handle) : null;
      })
      .catch(function () { return null; }));
  }
  /* The handle off the redirect's final URL; the page body is never read. */
  function byVariant(v) {
    var ctl = w.AbortController ? new w.AbortController() : null;
    return memo['v' + v] || (memo['v' + v] = w.fetch('/variants/' + v, { credentials: 'same-origin', signal: ctl ? ctl.signal : undefined })
      .then(function (r) {
        var m = /\/products\/([^/?#]+)/.exec(r.url || '');
        if (ctl) ctl.abort();
        return r.ok && m ? byHandle(decodeURIComponent(m[1])) : null;
      })
      .catch(function () { return null; }));
  }
  /* {image, title, handle} or null; a handle that no longer resolves falls
     through to the variant, and both to the title. */
  function lookup(s) {
    var h = handleOf(s), v = vidOf(s), t = titleOf(s);
    return (h ? byHandle(h) : Promise.resolve(null))
      .then(function (p) { return p || !/^\d+$/.test(v) ? p : byVariant(v); })
      .then(function (p) { return p || !t ? p : byTitle(t); })
      .then(function (p) { return p ? { image: pic(p, v), title: p.title, handle: p.handle } : null; });
  }

  function paint(img, s, width) {
    s = s || {};
    var key = img.__stsPic = {}, first = own(s);
    function ph() {
      img.onerror = img.onload = null;
      img.setAttribute('data-sts-ph', '');
      img.src = icon(s.slot);
    }
    /* A picture that loads as a 1-7px spacer is a failure too: it drew an
       empty tile and fired no error. */
    function show(u, fail) {
      img.onerror = fail;
      img.onload = function () { if (img.naturalWidth > 0 && img.naturalWidth < 8) fail(); };
      img.removeAttribute('data-sts-ph');
      img.src = sized(u, width);
    }
    function look() {
      ph();
      if (vidOf(s) || handleOf(s) || titleOf(s)) {
        lookup(s).then(function (r) {
          if (img.__stsPic !== key || !r || !r.image || bare(r.image) === bare(first)) return;
          show(r.image, ph);
        });
      }
    }
    if (!first) return look();
    show(first, look);
  }

  var WAIT = 'sts.oosWait', held = {};
  function waitList() {
    try { var a = JSON.parse(w.localStorage.getItem(WAIT) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function waiting(v) { v = str(v); return !!v && (!!held[v] || waitList().indexOf(v) > -1); }

  /* sts-routine-shared.js isValidSwapCandidate / stepFieldsFromCandidate, for
     pages without it; standIn() is handed that file's own where it loads. */
  function valid(c, slot) {
    return !!c.dtcVariantId && !!c.title && c.inStock !== false &&
      (!slot || !c.slot || (STS.sameSlot ? STS.sameSlot(c.slot, slot) : c.slot === slot));
  }
  function fields(c) {
    return {
      title: c.title, displayTitle: c.displayTitle || c.title, brand: c.brand, image: c.image,
      priceMsrp: c.priceMsrp, dtcVariantId: c.dtcVariantId, inStock: c.inStock, handle: c.handle,
      keyIngredients: c.keyIngredients || [], ingredientsSummary: null, url: null, badges: c.badges
    };
  }

  function standIn(s, ok, map) {
    if (!s || s.inStock !== false || s.substituted === true || waiting(vidOf(s))) return s;
    var A = STS.ab, best = A && A.best;
    var list = (s.swapCandidates || []).filter(function (c) { return !!c && c.approved !== false && (ok || valid)(c, s.slot); });
    if (best && A.arm && A.arm() === 'few') list = list.filter(best).concat(list.filter(function (c) { return !best(c); }));
    if (!list[0]) return s;
    var f = (map || fields)(list[0]), was = {};
    Object.keys(f).forEach(function (k) { was[k] = s[k] === undefined ? null : s[k]; });
    return Object.assign({}, s, f, { substituted: true, substitutedFrom: s.displayTitle || s.title || null, oosOriginal: was });
  }

  function keep(s) {
    var o = s && s.oosOriginal, v = o && str(o.dtcVariantId);
    if (!o) return s;
    if (v) {
      held[v] = 1;
      try { w.localStorage.setItem(WAIT, JSON.stringify(waitList().filter(function (x) { return x !== v; }).concat(v).slice(-20))); } catch (e) { /* this page only */ }
    }
    return Object.assign({}, s, o, { substituted: false, substitutedFrom: null, oosOriginal: null });
  }

  /* QA 2026-10-01: the widget priced 4 of 9 steps off the backend's stored
     priceMsrp (PCA Facial Wash $42, the store's $46). prices(list) gives each
     step, and each of its swap candidates, the variant's live price in the
     buyer's market - the Storefront read the Skin Profile and results make,
     with the public token the page prints on [data-sf-token]. A variant it
     cannot see keeps its figure. No token: STS.money.reprice, as before. */
  function prices(list) {
    var el = d.querySelector('[data-sf-token]'), tok = el && el.getAttribute('data-sf-token'), M = STS.money, ids = [], seen = {};
    function fallback() { return M && M.reprice && M.code() !== M.shop ? M.reprice(list) : list; }
    (list || []).forEach(function (s) {
      [s].concat((s && s.swapCandidates) || []).forEach(function (x) {
        var v = vidOf(x);
        if (/^\d+$/.test(v) && !seen[v]) { seen[v] = 1; ids.push('gid://shopify/ProductVariant/' + v); }
      });
    });
    if (!tok || !ids.length) return Promise.resolve(fallback());
    var dom = el.getAttribute('data-sf-domain'), c = el.getAttribute('data-country');
    return w.fetch((dom ? 'https://' + dom : '') + '/api/2024-10/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': tok },
      body: JSON.stringify({
        query: 'query P($ids:[ID!]!,$c:CountryCode!)@inContext(country:$c){nodes(ids:$ids){...on ProductVariant{id price{amount} compareAtPrice{amount}}}}',
        variables: { ids: ids, c: /^[A-Z]{2}$/.test(c || '') ? c : 'US' }
      })
    }).then(function (r) { return r.json(); }).then(function (j) {
      var by = {};
      j.data.nodes.forEach(function (n) { if (n && n.price) by[str(n.id)] = n; });
      function live(x) {
        var n = x && by[vidOf(x)], p = n ? +n.price.amount : NaN, was = n && n.compareAtPrice ? +n.compareAtPrice.amount : 0;
        return isFinite(p) ? Object.assign({}, x, { priceMsrp: p, compareAt: was > p ? was : null }) : x;
      }
      return list.map(function (s) {
        s = live(s);
        return s && s.swapCandidates ? Object.assign({}, s, { swapCandidates: s.swapCandidates.map(live) }) : s;
      });
    }).catch(fallback);
  }

  STS.stepFallback = {
    prices: prices,
    paint: paint,
    lookup: lookup,
    icon: icon,
    standIn: standIn,
    keep: keep,
    waiting: waiting,
    note: function (s) {
      return s.substitutedFrom + ' is out of stock, so we picked ' + (s.displayTitle || s.title || 'another product') + ' for now.';
    },
    keepButton: function (cls, onKeep, css) {
      var b = d.createElement('button');
      b.type = 'button';
      b.className = cls;
      if (css) b.style.cssText = css;
      b.textContent = 'Keep waiting for it';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); onKeep(); });
      return b;
    }
  };
}(window, document));
